import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateCoMaedcv } from '../../helpers/api_helper';

const useUpdateCoMaedcv = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    const updateCoMaedcvRecord = async (claemp, tipfol, numfol, datosCoMaedcv) => {
        setLoading(true);
        setError(null);
        try {
            console.log('Datos a actualizar:', datosCoMaedcv);
            const response = await updateCoMaedcv(claemp, tipfol, numfol, {
                coMaedcvData: datosCoMaedcv,
                tenantId
            });
            console.log('Response from API:', response);
            if (response.success) {
                console.log('CO_MAEDCV actualizado con éxito');
                return { success: true };
            } else {
                throw new Error(response.message || 'Error al actualizar el registro CO_MAEDCV');
            }
        } catch (err) {
            const errorMessage = `Failed to update co_maedcv: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            console.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { updateCoMaedcv: updateCoMaedcvRecord, loading, error };
};

export default useUpdateCoMaedcv;